

document.addEventListener("DOMContentLoaded", function() {
    const useModal = localStorage.getItem('hertz-open-cart');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    
    
    if (useModal) {
        if (cart && typeof cart.open === 'function') {
            cart.open();
        }
       localStorage.removeItem('hertz-open-cart');
    }
});   

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

        getSelectedUpsellItems() {
        const items = [];
        const upsellWrappers = document.querySelectorAll('.dev-upsell');

        upsellWrappers.forEach((wrapper) => {
            const upsellItems = wrapper.querySelectorAll('[data-upsell-item]');

            upsellItems.forEach((item) => {
            const checkbox = item.querySelector('.dev-upsell-check');
            const qtyInput = item.querySelector('[data-upsell-qty]');
            const variantId = item.getAttribute('data-variant-id');

            if (!checkbox || !variantId) return;
            if (!checkbox.checked || checkbox.disabled) return;

            let quantity = 1;

            if (qtyInput) {
                const parsedQty = parseInt(qtyInput.value || '0', 10);
                quantity = parsedQty > 0 ? parsedQty : 1;
            }

            items.push({
                id: Number(variantId),
                quantity: quantity,
            });
            });
        });

        return items;
        }

        async addUpsellsToCart(items) {
        if (!items.length) return null;

        const payload = { items };

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
        }

        const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
            throw new Error(data.description || 'Erro ao adicionar acessórios.');
        }

        return data;
        }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const upsellItems = this.getSelectedUpsellItems();

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          let responseData = await response.json();

          if (responseData.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: responseData.errors || responseData.description,
              message: responseData.message,
            });

            this.handleErrorMessage(responseData.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.cart) {
            if (upsellItems.length) {
              await this.addUpsellsToCart(upsellItems);
            }

            window.location = window.routes.cart_url;
            return;
          }

            if (upsellItems.length) {
            const upsellResponse = await this.addUpsellsToCart(upsellItems);

            if (upsellResponse && upsellResponse.sections) {
                responseData = upsellResponse;
            }
            }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: responseData,
            });
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(responseData);
                });
              },
              { once: true }
            );

            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(responseData);
          }
        } catch (e) {
          console.error(e);
          this.handleErrorMessage(e.message || 'Erro ao adicionar ao carrinho.');
          setTimeout(() => {
            localStorage.setItem('hertz-open-cart', 'true');
            window.location.reload();
          }, 1000);
        } finally {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}